var render = function render(){
  var _vm$documents;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "vendor-documents mt-4"
  }, [_c('div', {
    staticClass: "d-flex justify-content-end mb-3"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "danger",
      "size": "sm",
      "disabled": !_vm.hasSelected
    },
    on: {
      "click": _vm.deleteSelected
    }
  }, [_c('i', {
    staticClass: "fas fa-trash-alt"
  }), _vm._v(" Delete Selected ")]), _c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": _vm.addRow
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v(" Add New Row ")])], 1), _c('table', {
    staticClass: "table align-middle"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "40px"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "checked": ((_vm$documents = _vm.documents) === null || _vm$documents === void 0 ? void 0 : _vm$documents.every(function (doc) {
        return doc === null || doc === void 0 ? void 0 : doc.selected;
      })) && _vm.documents.length > 0
    },
    on: {
      "change": _vm.toggleAll
    }
  })], 1), _c('th', [_vm._v("Document Name")]), _c('th', [_vm._v("Document Upload")]), _c('th', {
    staticStyle: {
      "width": "40px"
    }
  })])]), _c('tbody', [_vm._l(_vm.documents, function (doc, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('b-form-checkbox', {
      on: {
        "change": _vm.updateSelectAll
      },
      model: {
        value: doc.selected,
        callback: function callback($$v) {
          _vm.$set(doc, "selected", $$v);
        },
        expression: "doc.selected"
      }
    })], 1), _c('td', {
      staticStyle: {
        "width": "45%"
      }
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.getAvailableDocumentOptions(index),
        "size": "sm"
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('option', {
            attrs: {
              "disabled": ""
            },
            domProps: {
              "value": null
            }
          }, [_vm._v("Select Document")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: doc.document_name,
        callback: function callback($$v) {
          _vm.$set(doc, "document_name", $$v);
        },
        expression: "doc.document_name"
      }
    })], 1), _c('td', {
      staticStyle: {
        "width": "45%"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('b-form-file', {
      attrs: {
        "size": "sm",
        "browse-text": "Browse",
        "placeholder": "Choose file..."
      },
      on: {
        "change": function change($event) {
          return _vm.updateFileName(index);
        }
      },
      model: {
        value: doc.file_path,
        callback: function callback($$v) {
          _vm.$set(doc, "file_path", $$v);
        },
        expression: "doc.file_path"
      }
    }), _vm._m(0, true)], 1)]), _c('td', {
      staticClass: "text-center"
    }, [_c('b-button', {
      staticClass: "text-danger p-0",
      attrs: {
        "variant": "link",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.deleteRow(index);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash-alt"
    })])], 1)]);
  }), !_vm.documents || _vm.documents.length === 0 ? _c('tr', [_vm._m(1)]) : _vm._e()], 2)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('small', [_vm._v(" File Type : "), _c('b', [_vm._v(".Pdf")])]), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("|")]), _c('small', [_vm._v(" Max File Size : "), _c('b', [_vm._v("25 MB")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', {
    staticClass: "text-center p-4",
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "empty-state"
  }, [_c('i', {
    staticClass: "fas fa-file-alt text-muted mb-3",
    staticStyle: {
      "font-size": "3rem"
    }
  }), _c('h6', {
    staticClass: "text-muted mb-2"
  }, [_vm._v("No Documents Added")]), _c('p', {
    staticClass: "text-muted mb-3"
  }, [_vm._v(" Start by uploading your first document ")])])]);

}]

export { render, staticRenderFns }